import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-front-load-washing-machine-service-bangalore", label: "LG Front Load Service" },
  { to: "/lg-top-load-washing-machine-service-bangalore", label: "LG Top Load Service" },
];

const LGWashingMachineNotSpinning = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Not Spinning Repair in Bangalore"
      description="LG washing machine not spinning repair in Bangalore for belt issues, motor faults, load imbalance, and drum-related problems."
      keywords="lg washing machine not spinning, lg spin problem repair bangalore, lg washer drum issue"
      path="/lg-washing-machine-not-spinning"
      bannerTitle="LG Washing Machine Not Spinning"
      intro={<>An <span style={{ fontWeight: 'bold' }}>LG washing machine not spinning</span> can leave clothes wet and unfinished after every wash cycle. Our Bangalore technicians inspect the motor, drum, capacitor, belt, and related components to restore proper spinning performance.</>}
      highlights={[
        "Diagnosis for spin cycle failures",
        "Drum, belt, and motor component checks",
        "Capacitor and control panel inspection",
        "Repair support for repeated spin interruptions",
      ]}
      issues={[
        "Drum not rotating",
        "Clothes remain wet after wash",
        "Machine stops before spin cycle",
        "Excess vibration during spinning",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineNotSpinning;
